import store from 'store'
import { USER_ROLES_ENUM } from './constant'

let globalUser
let isLoggingIn

export function getPermission () {
  return getUser()?.userPermissions || []
}

export function getRefreshToken () {
  return getUser()?.refreshToken
}

export function getRole () {
  return getUser()?.userRoles || []
}

export function getToken () {
  return getUser()?.accessToken
}

export function getUser () {
  if (typeof window === 'undefined') {
    return {
      userRoles: Object.freeze([]),
      userPermissions: Object.freeze([])
    }
  }

  let user = globalUser
  if (!user) {
    try {
      user = JSON.parse(window.sessionStorage.getItem('user') || window.localStorage.getItem('user'))
    } catch (e) {
      console.log(e)
    }
    return user
  }
  if (!user) {
    logout()
    window.open('/login', '_self')
  }
  return user
}

export function getUserName () {
  return getUser()?.userName
}

export function isLoggedIn () {
  if (typeof window === 'undefined') {
    return false
  }
  const isLoggingIn = getLoginState()
  return isLoggingIn && !!getUser()
}

export function logout () {
  globalUser = null
  document.cookie = 'login=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/'
  clearScheduleModalCookie() // Xóa cookie modal khi logout để popup bật lại khi login
  isLoggingIn = false
  store.remove('user')
}

export function setToken (token) {
  setUserField('accessToken', token.accessToken)
  setUserField('refreshToken', token.refreshToken)
}

export function setUser (user, keepLogin) {
  const { accessToken, refreshToken, userId, userName, userRoles, userPermissions } = user
  globalUser = {
    accessToken,
    refreshToken,
    userId,
    userName,
    userRoles: Object.freeze(userRoles),
    userPermissions: Object.freeze(userPermissions.map(p => p.code))
  }
  storeUser(globalUser)
  setLoginState(keepLogin)
}

function setLoginState (keepLogin) {
  isLoggingIn = true
  let expire = ''
  if (keepLogin && !hasRole(USER_ROLES_ENUM.EMPLOYEE_TEACHER)) {
    expire = '; Expires=Wed, 21 Oct 9999 07:28:00 GMT'
  }
  document.cookie = `login=1${expire}; path=/`
  if (hasRole(USER_ROLES_ENUM.EMPLOYEE_TEACHER)) {
    document.cookie = `showModal=1; path=/`
  }
}

function getLoginState () {
  if (isLoggingIn) return true
  return /(login=1)/.test(document.cookie)
}

export function isShowModalState () {
  return /(showModal=1)/.test(document.cookie)
}

function storeUser (user) {
  store.set('user', user)
}

export function setUserField (field, value) {
  const user = getUser()
  user[field] = value
  storeUser(user)
}

export const hasRole = (roles) => {
  const user = getUser()
  return user?.userRoles?.some((role) =>
    roles.includes(role)
  )
}

export function getUserId () {
  return getUser()?.userId || []
}

// ===== Hàm mới cho modal thông báo lịch học =====

export function isShowScheduleNotificationModal () {
  // Check nếu ngày hiện tại trong khoảng 3/2/2026 - 14/2/2026
  const today = new Date()
  const year = today.getFullYear()
  const month = String(today.getMonth() + 1).padStart(2, '0')
  const day = String(today.getDate()).padStart(2, '0')
  const todayString = `${year}-${month}-${day}` // Format: YYYY-MM-DD

  // Kiểm tra ngày hiện tại trong khoảng 3/2/2026 - 14/2/2026
  const startDate = '2026-02-24'
  const endDate = '2026-02-28'

  if (todayString < startDate || todayString > endDate) {
    return false
  }

  // Check cookie lần cuối user xem modal
  const cookieValue = document.cookie.split('; ').find(row => row.startsWith('scheduleModalShownDate='))?.split('=')[1]

  // Nếu chưa xem hoặc ngày trong cookie khác ngày hôm nay thì cho phép hiển modal
  return !cookieValue || cookieValue !== todayString
}

export function markScheduleModalAsShown () {
  const today = new Date()
  const dateString = today.toISOString().split('T')[0] // Format: YYYY-MM-DD

  // Set expires cuối ngày hôm nay (24h)
  const tomorrow = new Date(today)
  tomorrow.setDate(tomorrow.getDate() + 1)
  tomorrow.setHours(0, 0, 0, 0)
  const expires = tomorrow.toUTCString()

  document.cookie = `scheduleModalShownDate=${dateString}; path=/; expires=${expires}`
}

export function clearScheduleModalCookie () {
  document.cookie = 'scheduleModalShownDate=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/'
}
